// CONTRACT (phase 4): shared types between src/api, src/auth and the shell.

/** An HTTP failure in the portal's dialect (ADR 0006). */
export class HttpError extends Error {
  readonly status: number
  readonly body: unknown
  constructor(status: number, message: string, body: unknown) {
    super(message)
    this.name = 'HttpError'
    this.status = status
    this.body = body
  }
}

/** How the HTTP client reaches auth without importing it (wired in app/providers). */
export interface HttpAuth {
  /** A fresh Oase token (refreshing when < 10 min left), or null when signed out. */
  getToken(): Promise<string | null>
  /** 401, or a token that cannot be refreshed: sign out and go to /login (ADR 0008). */
  onUnauthorized(): void
}

export type SortOrder = 'ASC' | 'DESC'

export interface ListQuery {
  sort?: string
  order?: SortOrder
  /** Flat filters, sent as query params with the portal's exact names. */
  filter?: Record<
    string,
    string | number | boolean | readonly (string | number)[] | null | undefined
  >
  /** Offsets: `_start` / `_end`. */
  start: number
  end: number
  /** Extra query params the portal sends on some calls (e.g. embedded upgrade process `tenantId`). */
  params?: Record<string, string>
}

export interface ListResult<T> {
  rows: T[]
  /** From X-Total-Count; undefined when absent or unparsable — never 0 by default (ADR 0007). */
  total: number | undefined
  /** From Link rel="next" / X-Has-Next-Page, only when the capability flag says so. */
  hasNextPage: boolean | undefined
}

export type RecordId = string | number
